     import React from 'react';

import Layout from '../components/layout';
import Slider from '../components/slider';
import { Box, Text, Stack, _hover, Flex } from '@chakra-ui/core';
import PageWrapper from '../components/page.wrapper';

import {
    FaFacebookF,
    FaTwitter,
    FaLinkedinIn,
    FaGithub,
    FaEnvelope,
    FaPhoneAlt,
    FaMapMarkerAlt,
    FaInstagram,
} from 'react-icons/fa';

const img = require('../images/innerbanner.jpg');
const imgNew = require('../images/carehome/vaccination.jpg');
 


const Vaccination = () => (
    <Layout>
        <Box className="sub-menu">
            <Box className="sub-banner" style={{ backgroundImage: `url(${img})` }} />
            <Box className="content-row">
				<h1>Vaccination</h1>
                <Flex align="center" className="flex-row">
                    <Box flex="1" p="4">
                        <Box as="img" src={imgNew} w="100%" />
						 
                    </Box>

                    <Box flex="1" p="4" className="brief-para">
                        <p>
                           Administration of all types vaccines for all age groups as prescribed by industries/Establishment standard under the supervision medical experts, especially for Food establishment and industries provide entire range of vaccinations administered with nominal cost at their office premises
  
                        </p>
						 
                    </Box>
                </Flex>
            </Box>
        </Box>
    </Layout>
);

export default Vaccination;